<app-header></app-header>

<div class="page-title-area newsBg">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routeLink="/">Acasa</a></li>
                <li><a routeLink="/anunturi">Anunturi</a></li>
                <li>Anunt</li>
            </ul>
            <h2>{{news.title}}</h2>
        </div>
    </div>
</div>
<section class="bg my-5">
    <div class="container">
        <div class="row">
            <div class="col-12 newsDetail">

                <div *ngIf="news.photo"><img [src]="setFilePath(news)" alt="test"></div>
                <div *ngIf="!news.photo"><img src="../../../assets/img/placeImg.jpg" alt=""></div>

                <div class="content">
                    <div class="date"></div>
                    <h3>{{news.title}}</h3>
                    <div [innerHTML]=news.content></div>
                </div>
            </div>
        </div>
    </div>
</section>
